import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import classNames from 'classnames';
import RatingForm from './rating.form';

import './rating.scss';

const star =
    (
        <svg width='19' height='20'>
            <path
                d='M10 14l-5.878 4.09 2.074-6.854L.489 6.91l7.16-.146L10 0l2.351 6.764 7.16.146-5.707 4.326 2.074 6.854z'
                stroke='#237CB5'
                fill='none'
                fillRule='evenodd'
            />
        </svg>
    ),
    plus = (
        <svg width='12px' height='12px' viewBox='0 0 12 12'>
            <path
                d='M7,5 L11,5 C11.5522847,5 12,5.44771525 12,6 C12,6.55228475 11.5522847,7 11,7 L7,7 L7,11 C7,11.5522847 6.55228475,12 6,12 C5.44771525,12 5,11.5522847 5,11 L5,7 L1,7 C0.44771525,7 0,6.55228475 0,6 C0,5.44771525 0.44771525,5 1,5 L5,5 L5,1 C5,0.44771525 5.44771525,1.01453063e-16 6,0 C6.55228475,-1.01453063e-16 7,0.44771525 7,1 L7,5 Z'
                fill='#237CB5'
            />
        </svg>
    );

@inject('appStore')
@observer
export default class RatingComponent extends Component {
    @observable expanded = false;
    @observable submitted = false;

    constructor(props) {
        super(props);
        this.ratingForm = new RatingForm({
            store: props.appStore,
            appStore: props.appStore
        });
    }

    onStarMouseEnter(e, id) {
        for (var i = 1; i < id + 1; i++) {
            this['star' + i].classList.add('ht-rating-form-rating-star--hover');
        }
    }

    onStarMouseLeave(e, id) {
        for (var i = 1; i < 6; i++) {
            this['star' + i].classList.remove(
                'ht-rating-form-rating-star--hover'
            );
        }
    }

    getRatingLabel(id) {
        const classes = classNames({
            'ht-rating-form-rating-star': true,
            'ht-rating-form-rating-star--active':
                id <= this.ratingForm.$('Rating').value
        });

        return (
            <label
                tabIndex='0'
                className={classes}
                key={`rating-${id}`}
                htmlFor={`rating-${id}`}
                onMouseEnter={e => this.onStarMouseEnter(e, id)}
                onMouseLeave={e => this.onStarMouseLeave(e, id)}
                ref={label => (this['star' + id] = label)}
            >
                <span className='sr-only'>{id} Star</span>
                {star}
            </label>
        );
    }

    getSubmittedRatingLabel(id, value) {
        const classes = classNames({
            'ht-rating-form-rating-star': true,
            'ht-rating-form-rating-star--submitted': true,
            'ht-rating-form-rating-star--active':
                id <= value
        });

        return (
            <span
                tabIndex='0'
                className={classes}
                key={`rating-${id}`}
            >
                <span className='sr-only'>{id} Star</span>
                {star}
            </span>
        );
    }

    getRatingInput(id) {
        return (
            <input
                className='sr-only'
                {...this.ratingForm.$('Rating').bind({
                    id: `rating-${id}`,
                    value: id
                })}
            />
        );
    }

    onExpand(e) {
        e.preventDefault();
        this.expanded = !this.expanded;
    }

    onSubmit(e) {
        e.preventDefault();
        this.submitted = true;
        this.ratingForm.onSubmit(e);
    }

    renderStars() {
        return <div className='ht-rating-form-rating-field'>
            {/*
                Not using a .map() to render, because
                the items then will need a common ancestor (JSX pre React 16)
                which will break the CSS styling for focused state (using the + selector)
            */}
            {this.getRatingInput(1)}
            {this.getRatingLabel(1)}
            {this.getRatingInput(2)}
            {this.getRatingLabel(2)}
            {this.getRatingInput(3)}
            {this.getRatingLabel(3)}
            {this.getRatingInput(4)}
            {this.getRatingLabel(4)}
            {this.getRatingInput(5)}
            {this.getRatingLabel(5)}
        </div>;
    }

    renderSubmittedStars(value) {
        return <div className='ht-rating-form-rating-field'>
            {this.getSubmittedRatingLabel(1, value)}
            {this.getSubmittedRatingLabel(2, value)}
            {this.getSubmittedRatingLabel(3, value)}
            {this.getSubmittedRatingLabel(4, value)}
            {this.getSubmittedRatingLabel(5, value)}
        </div>;
    }

    renderSubmission() {
        const { appStore } = this.props,
            { ratingValue, ratingComments } = appStore,
            { RatingBlockIntro, RatingBlockSuccess } = window.HTContent;

        return (
            <>
                {RatingBlockSuccess && (
                    <h4
                        className='ht-rating-form-title'
                        id='ht-rating-title'
                    >
                        { RatingBlockSuccess }
                    </h4>
                )}
                {RatingBlockIntro && (
                    <p
                        className='ht-rating-form-intro'
                        dangerouslySetInnerHTML={{ __html: RatingBlockIntro }}
                    />
                )}
                {ratingValue !== false && (
                    <>
                        {this.renderSubmittedStars(ratingValue)}
                    </>
                )}
                {ratingComments !== false && (
                    <p className='ht-rating-submitted-comments'>{ratingComments}</p>
                )}
            </>
        );
    }

    renderForm() {
        const { RatingBlockTitle, RatingBlockIntro } = window.HTContent,
            canSubmit = this.ratingForm.$('Rating').value,
            commentsClasses = classNames({
                'ht-rating-comments': true,
                'ht-rating-comments--expanded':
                    this.ratingForm.$('Rating').value || this.expanded
            });

        return (
            <form
                className='ht-rating-form'
                onSubmit={this.ratingForm.onSubmit}
            >
                {RatingBlockTitle && (
                    <h4
                        className='ht-rating-form-title'
                        id='ht-rating-title'
                    >
                        { RatingBlockTitle }
                    </h4>
                )}
                {RatingBlockIntro && (
                    <p
                        className='ht-rating-form-intro'
                        dangerouslySetInnerHTML={{ __html: RatingBlockIntro }}
                    />
                )}
                <div
                    role='radiogroup'
                    aria-labelledby='ratingsTitle'
                    className='ht-rating-form-fieldset'
                    ref={group => (this.radiogroup = group)}
                >
                    {this.renderStars()}
                </div>
                {!this.ratingForm.$('Rating').value && !this.expanded && (
                    <button
                        className='ht-rating-button'
                        onClick={e => this.onExpand(e)}
                        aria-controls='ratingcomments'
                        aria-expanded={this.expanded}
                        id='ht-rating-expand'
                    >
                        {plus}
                        Add a comment
                    </button>
                )}
                <div
                    className={commentsClasses}
                    id='ht-rating-comments'
                    aria-hidden={!this.expanded}
                    aria-expanded={this.expanded}
                >
                    <div className='ht-rating-form-comments-field'>
                        <label
                            className='sr-only'
                            htmlFor={
                                this.ratingForm.$('Comments').id
                            }
                        >
                            Additional comments
                        </label>
                        <textarea
                            className='ht-rating-form-comments'
                            {...this.ratingForm
                                .$('Comments')
                                .bind()}
                        />
                    </div>
                    <button
                        type='submit'
                        className='ht-button ht-rating-form-action'
                        aria-disabled={!canSubmit}
                        disabled={!canSubmit}
                        onClick={e => this.onSubmit(e)}
                        id='ht-rating-submit'
                    >
                        Submit
                    </button>
                </div>
            </form>
        );
    }

    render() {
        const { appStore } = this.props,
            { ratingError, ratingSubmitted } = appStore,
            canRate = !ratingSubmitted.value,
            classes = classNames({
                'ht-rating ht-section': true,
                'ht-rating--expanded': this.expanded
            }),
            { EnableRating } = window.HTContent;

        if (!EnableRating || (!this.submitted && !canRate)) {
            return null;
        }

        return (
            <div className={classes}>
                <div className='ht-section-left' />
                <div className='ht-section-right'>
                    {ratingError && ratingError.response
                        ? <p className='ht-rating-message'>
                            An error occurred
                            <br />
                            Please try again later
                        </p>
                        : this.submitted
                            ? <>
                                {this.renderSubmission()}
                            </>
                            : canRate ? <> {this.renderForm()}</> : <div />}
                </div>
            </div>
        );
    }
}
